export const actionTypes: any = {
  GET_ICARD_REQUESTS_REPORT_START: 'GET_ICARD_REQUESTS_REPORT_START',
  GET_ICARD_REQUESTS_REPORT_SUCCESS: 'GET_ICARD_REQUESTS_REPORT_SUCCESS',
  GET_ICARD_REQUESTS_REPORT_FINISH: 'GET_ICARD_REQUESTS_REPORT_FINISH',
}
